var CountySelect = (function($) {
    var addCountyChangeHandler = function (countySelect, townSelect) {

        $(countySelect).on("change", function (event) {
            var target = $(event.target);
            populateTownSelectBox(townSelect, target.val());
        });
    };

    var populateTownSelectBox = function (townSelect, county) {

        var townSelectBox = $(townSelect);
        var url = "/external/county/get";
        var previousSelected = "";
        if (townSelectBox.data("value")) {
            previousSelected = townSelectBox.data("value");
        }

        if (townSelectBox.length > 0 && url) {
            townSelectBox.prop("disabled", true);
            $.ajax({
                url: url,
                type: "POST",
                cache: false,
                data: "countyName=" + county,
                success: function (data) {

                    reset(townSelectBox);
                    if(data) {
                        var selected = false;
                        if (Object.keys(data["cities"]).length == 1) {
                            selected = true;
                        }
                        if (Object.keys(data["cities"]).length > 1) {
                            townSelectBox.prop("disabled", false);
                        }
                        $.each(data.cities, function (i, city) {
                            if(city.selected || selected || (previousSelected == city.cityName)) {
                                $("#invoiceAddress\\.cityId").val(city.cityId);
                            }
                            townSelectBox.append($('<option>', {
                                value: city.cityName,
                                text : city.cityName,
                                selected : city.selected || selected || (previousSelected == city.cityName)
                            }).attr("data-cityid", city.cityId));
                        });
                    }
                    if($(townSelect+" option:selected").val() != previousSelected ){
                        townSelectBox.trigger('change');
                    }

                    window.THEME.$document.trigger("cityConfirm", [$(this)]);
                }
            });

        }
    };

    var initRegion = function (town, region) {
        $.get( "/external/region", function( data ) {
            $(region).each(function(){
                var currentRegion = $(this);
                var previousValue = currentRegion.data('value');
                $.each(data, function (i, variable) {
                    var option = $('<option>', {value: variable, text: variable});
                    if(previousValue == variable){
                        option.prop('selected', true);
                    }
                    currentRegion.append(option);
                });
            });
            populateTownSelectBox(town, $(region).data("value"));
        });
    };

    return {
        addCountyChangeHandler: addCountyChangeHandler,
        populateTownSelectBox: populateTownSelectBox,
        initRegion: initRegion
    }
})(jQuery);

function isSelectorDefined(variable){
    var testVariable = $(variable)
    return (typeof testVariable !== 'undefined') && (typeof testVariable.val() !== 'undefined');
}

function reset(select){
    select.find('option:not(:first)').remove();
    select.find('option:first').prop('selected', true);
    select.prop("disabled","disabled");

}

$(document).ready(function() {
    var invoiceCountySelect = ".invoice-county-select";
    var invoiceTownSelect = ".invoice-town-select";
    if (isSelectorDefined(invoiceCountySelect)) {
        if (!$(invoiceCountySelect).find("option").filter(function(){return $(this).val() != ''}).length) {
            CountySelect.initRegion(invoiceTownSelect, invoiceCountySelect);
        } else {
            CountySelect.populateTownSelectBox(invoiceTownSelect, $(invoiceCountySelect).data("value"));
        }
        CountySelect.addCountyChangeHandler(invoiceCountySelect, invoiceTownSelect);
    }
    var deliveryCountySelect = ".delivery-county-select";
    var deliveryTownSelect = ".delivery-town-select";
    if (isSelectorDefined(deliveryCountySelect)) {
        if (!$(deliveryCountySelect).find("option").filter(function(){return $(this).val() != ''}).length) {
            CountySelect.initRegion(deliveryTownSelect, deliveryCountySelect);
        } else {
            CountySelect.populateTownSelectBox(deliveryTownSelect, $(deliveryCountySelect).data("value"));
        }
        CountySelect.addCountyChangeHandler(deliveryCountySelect, deliveryTownSelect);
    }
});
